import Breadcrumb from 'components/seo/breadcrumb/breadcrumb';
import ButtonContainer from 'core/button-container';
import FormOrRedirectButton from 'components/landing/home-landing/form-or-redirect-button/form-or-redirect-button';
import LandingSection from 'components/landing/components/landing-section';
import PropTypes from 'prop-types';
import Slider from 'components/home/insurace/insurace-slider/insurace-slider';
import Spacer from 'core/spacer';
import Text from 'core/text';
import Title from 'core/title';

const InsuranceSlider = ({
    culture,
    messages,
    showText = false,
    redirectWithConversio = false,
    showBreadcrumb = false
}) => {
    return (
        <LandingSection disableTopPadding={showBreadcrumb}>
            {
                showBreadcrumb &&
                <>
                    <Spacer />
                    <Breadcrumb />
                    <Spacer />
                </>
            }
            <Title align content={messages.title} tag="h2" />
            <Slider />
            {showText && <Text
                align
                content={messages.description}
                width="40%"
                marginBottom="40px"
                mobileText /> }
            <ButtonContainer>
                <FormOrRedirectButton
                    label={messages.button.label}
                    href={messages.button.href}
                    redirectWithConversio={redirectWithConversio && culture === 'es-ar'}
                />
            </ButtonContainer>
        </LandingSection>
    );
};

InsuranceSlider.propTypes = {
    showText: PropTypes.bool,
    redirectWithConversio: PropTypes.bool,
    culture: PropTypes.string,
    showBreadcrumb: PropTypes.bool,
    messages: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        button: PropTypes.shape({
            label: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired
        }).isRequired
    }).isRequired
};

export default InsuranceSlider;
